import * as React from 'react';

export interface ICaps {
  /**
   * HTML Element
   * @default span
   */
  as?: string;
  /**
   * Tachyons color class
   * @default navy
   */
  color?: string;
  className?: string;
  style?: object;
}

const Caps: React.FunctionComponent<ICaps> = ({
  children,
  as = 'span',
  color = 'light-tan',
  className = '',
  ...rest
}) => {
  const Component: any = { tag: as };
  return (
    <Component.tag className={`f8 ttu tracked-mega fw5 ${color} ${className}`} {...rest}>
      {children}
    </Component.tag>
  );
};

export default Caps;
